interface IUseAniScrollProps {
  ref: React.RefObject<HTMLDivElement>; // ref
  duration: number; // 시간
  easeFunc: string; // ease 함수 이름
  targetPer: number; // 전체 넓이의 percent 위치
}

const easeFunction = (
  easeName: string,
  time: number,
  from: number,
  distance: number,
  duration: number,
) => {
  let timeValue = time;
  if (easeName === 'easeInOut') {
    timeValue /= duration / 2;
    if (timeValue < 1) {
      return (distance / 2) * timeValue ** 4 + from;
    }
    timeValue -= 2;
    return (-distance / 2) * (timeValue * timeValue ** 3 - 2) + from;
  }
  if (easeName === 'linear') {
    return (distance * time) / duration + from;
  }
  if (easeName === 'easeIn') {
    timeValue /= duration;
    return distance * timeValue * time + from;
  }
  if (easeName === 'easeOut') {
    timeValue /= duration;
    return -distance * timeValue * (time - 2) + from;
  }
  return from;
};

const useAniScroll = (props: IUseAniScrollProps) => {
  const { ref, duration, easeFunc, targetPer } = props;

  const aniScroll = (elName: string) => {
    if (ref && ref.current && document) {
      const elCon = ref.current;
      const elSelected = ref.current.querySelector(
        `#${elName}`,
      ) as HTMLButtonElement;
      const limitX = elCon.scrollWidth - elCon.offsetWidth + 1; // 1 은 offset
      let targetX = elSelected.offsetLeft - elCon.offsetWidth * targetPer;
      targetX = targetX > limitX ? limitX : targetX;
      const currentX = elCon.scrollLeft;
      const distanceX = targetX - currentX;

      const sTime = new Date().getTime();
      const eTime = sTime + duration;

      const scrollTo = () => {
        const now = new Date().getTime();
        const passed = now - sTime;
        if (now <= eTime) {
          elCon.scrollLeft = easeFunction(
            easeFunc,
            passed,
            currentX,
            distanceX,
            duration,
          );
          requestAnimationFrame(scrollTo);
        }
      };
      requestAnimationFrame(scrollTo);
    }
  };

  return { aniScroll };
};

export default useAniScroll;
